import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../../utils/common'
import { FileUpload, FileUploadPlaceholder } from '../../../File'
import { FloatingTooltip } from '../../../Floating'
import { QA_NAME_PHOTO_DROPZONE } from '../RentalPortalPhotoGallery.constants'
import { getPhotoDropzoneOptions } from '../RentalPortalPhotoGallery.utils'

import * as styles from './RentalPortalPhotoGalleryDropzone.module.css'

import ImageIcon from '../../../../icons/image.svg'

function RentalPortalPhotoGalleryDropzone({
  disabled,
  disabledReason,
  onErrorUpload,
  onFinishUpload,
  onGetUploadedFiles,
  onStartUpload,
}) {
  const { t } = useTranslation()

  return (
    <FloatingTooltip content={disabledReason} disabled={!disabled}>
      <div
        {...getQaSelector({ value: QA_NAME_PHOTO_DROPZONE })}
        className={styles.RentalPortalPhotoGalleryDropzone}
      >
        <FileUpload
          className={styles.upload}
          disabled={disabled}
          getFiles={onGetUploadedFiles}
          options={getPhotoDropzoneOptions()}
          onFinishUpload={onFinishUpload}
          onStartUpload={onStartUpload}
          onUploadErrors={onErrorUpload}
        >
          <FileUploadPlaceholder
            Icon={ImageIcon}
            className={styles.placeholder}
            disabled={disabled}
            text={t('RentalPortal.ListingPhotoDropzoneHintKey')}
          />
        </FileUpload>
      </div>
    </FloatingTooltip>
  )
}

export default RentalPortalPhotoGalleryDropzone
